import {observable, action, computed} from 'mobx';
import { isNumber } from 'util';


const minAge = 21;
const stepAge = 4;
const maxAge = 35;

class RealnameStore{
    @observable.shallow persons = [];

    @action setPersons(persons) {
        this.persons = persons;
    }

    // 实名制数据
    @observable.shallow realnames = [];

    @action setRealnames(realnames) {
        this.realnames = realnames;
    }

    @computed get userStatus() {
        const total = this.persons.length;
        const working = this.realnames.length;
        const htUser = {};
        const ageUser = {};
        this.realnames.forEach((user) => {
            const {hometown, age} = user;
            if (!htUser[hometown]) {
                htUser[hometown] = 0;
            }
            htUser[hometown]++;
            const range = getAgeRange(age);
            if (range) {
                if (!ageUser[range]) {
                    ageUser[range] = 0;
                }
                ageUser[range]++;
            }
        });
        return {
            total,
            working,
            htUser,
            ageUser
        }
    }
}

/**
 * 得到年龄所在范围
 * @param {*} value 
 */
function getAgeRange(value, range) {
    if (!isNumber(value)) {
        return null;
    }
    if (!range) {
        if (value < minAge) {
            return `0-${minAge - 1}`;
        } else {
            range = minAge;
            return getAgeRange(value, range);
        }
    }
    if (range > maxAge) {
        return `${maxAge}-100`;
    }
    const rightAge = range + stepAge;
    if (value >= range && value <= rightAge) {
        return `${range}-${rightAge}`;
    } else {
        return getAgeRange(value, rightAge + 1);
    }
}

export default new RealnameStore();